// Modules
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'sbi-cot-back-image-zoom-modal',
    templateUrl: './image-zoom-modal.component.html',
    styleUrls: ['./image-zoom-modal.component.scss'],
    standalone: false
})
export class ImageZoomModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
